/** `notifications` namespace — Swedish (source of truth). */
const notifications = {
  panel: {
    title: 'Aviseringar',
    description: 'Dina senaste aviseringar',
    bell: 'Aviseringar',
    markAllRead: 'Markera alla som lästa',
    empty: 'Inga aviseringar',
    loadMore: 'Ladda fler...',
  },
  tabs: {
    all: 'Alla',
    notification: 'Notiser',
    activity: 'Aktivitet',
  },
  time: {
    justNow: 'Just nu',
    minutesAgo: '{{count}} min sedan',
    hoursAgo_one: '{{count}} timme sedan',
    hoursAgo_other: '{{count}} timmar sedan',
    daysAgo_one: '{{count}} dag sedan',
    daysAgo_other: '{{count}} dagar sedan',
  },
}

export default notifications
